import { render, staticRenderFns } from "./AnnualLeaveStatus.vue?vue&type=template&id=5a349a90&"
import script from "./AnnualLeaveStatus.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports